'use client';

import { Wizard } from '@/components/wizard/Wizard';
import { useWorkspace } from '@/contexts/useWorkspace';

import { connectSaasWorkspaceStep } from './connectSaasWorkspaceStep';

export interface ConnectSaasWorkspaceState {
  provider: 'google-workspace' | 'microsoft-365';
  domain: string;
}

export function ConnectSaasWorkspaceWizard({
  onCreated,
}: {
  onCreated: () => void;
}) {
  const { rightPanel } = useWorkspace();

  return (
    <Wizard<ConnectSaasWorkspaceState>
      hideCloseButton={false}
      onAbort={() => rightPanel.setIsOpen(false)}
      hideBackArrow={true}
      onFinish={async () => {
        onCreated();
        return true;
      }}
      flow={[connectSaasWorkspaceStep]}
      title='Connect SaaS Workspace'
      initialState={{
        provider: 'google-workspace',
        domain: '',
      }}
    />
  );
}
